var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 6.65387H5C4.44772 6.65387 4 7.10158 4 7.65387V17.6539C4 18.2062 4.44772 18.6539 5 18.6539H19C19.5523 18.6539 20 18.2062 20 17.6539V7.65387C20 7.10158 19.5523 6.65387 19 6.65387ZM5 5.65387C3.89543 5.65387 3 6.5493 3 7.65387V17.6539C3 18.7584 3.89543 19.6539 5 19.6539H19C20.1046 19.6539 21 18.7584 21 17.6539V7.65387C21 6.5493 20.1046 5.65387 19 5.65387H5Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 10.6539H4V14.6539H6V10.6539ZM3 9.65387V15.6539H6C6.55228 15.6539 7 15.2062 7 14.6539V10.6539C7 10.1016 6.55228 9.65387 6 9.65387H3Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 14.6539L20 14.6539L20 10.6539L18 10.6539L18 14.6539ZM21 15.6539L21 9.65387L18 9.65387C17.4477 9.65387 17 10.1016 17 10.6539L17 14.6539C17 15.2062 17.4477 15.6539 18 15.6539L21 15.6539Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.461 19.6539V5.65387H12.461V19.6539H11.461Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 14.1539C12.8284 14.1539 13.5 13.4823 13.5 12.6539C13.5 11.8254 12.8284 11.1539 12 11.1539C11.1716 11.1539 10.5 11.8254 10.5 12.6539C10.5 13.4823 11.1716 14.1539 12 14.1539ZM12 15.1539C13.3807 15.1539 14.5 14.0346 14.5 12.6539C14.5 11.2732 13.3807 10.1539 12 10.1539C10.6193 10.1539 9.5 11.2732 9.5 12.6539C9.5 14.0346 10.6193 15.1539 12 15.1539Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourt);
export default __webpack_public_path__ + "static/media/court.8c602caaeef4c803bac883032dc4b6e9.svg";
export { ForwardRef as ReactComponent };